import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {EnrollmentModel} from "../../../domain/models/enrollment.model";
import {MatGridListModule} from "@angular/material/grid-list";
import {ContactInfoCardComponent} from "../../contact-info-card/contact-info-card.component";
import {AddressInfoCardComponent} from "../../address-info-card/address-info-card.component";
import {EnrollmentComponent} from "../EnrollmentComponent";
import {MatTabsModule} from "@angular/material/tabs";
import {EnrollmentOwnerComponent} from "../../enrollment-owner/enrollment-owner.component";
import {EnrollmentRentalPropertyComponent} from "../../enrollment-rental-property/enrollment-rental-property.component";
import {
  EnrollmentPropertyReportingComponent
} from "../../enrollment-property-reporting/enrollment-property-reporting.component";
import {
  EnrollmentPropertyLicensesComponent
} from "../../enrollment-property-licenses/enrollment-property-licenses.component";
import {EnrollmentRentalPropertyModel} from "../../../domain/models/enrollment-rental-property.model";
import {EnrollmentTaxRepresentativeModel} from "../../../domain/models/enrollment-tax-representative.model";
import {RentalPropertyLicenseModel} from "../../../domain/models/rental-license.model";
import {PropertyOwnerModel} from "../../../domain/models/property-owner.model";
import {PropertyCompanyModel} from "../../../domain/models/property-company.model";

@Component({
  selector: 'app-individual-owner-enrollment',
  standalone: true,
  imports: [MatGridListModule, ContactInfoCardComponent, AddressInfoCardComponent, MatTabsModule,
    EnrollmentOwnerComponent, EnrollmentRentalPropertyComponent, EnrollmentPropertyReportingComponent,
    EnrollmentPropertyLicensesComponent, EnrollmentOwnerComponent, EnrollmentRentalPropertyComponent,
    EnrollmentPropertyReportingComponent, EnrollmentPropertyLicensesComponent],
  templateUrl: './individual-owner-enrollment.component.html',
  styleUrl: './individual-owner-enrollment.component.css'
})
export class IndividualOwnerEnrollmentComponent implements EnrollmentComponent, OnInit {
  @Input() enrollment!: EnrollmentModel;
  @ViewChild(EnrollmentOwnerComponent) ownerComponent!: EnrollmentOwnerComponent;
  @ViewChild(EnrollmentRentalPropertyComponent) rentalComponent!: EnrollmentRentalPropertyComponent;
  @ViewChild(EnrollmentPropertyReportingComponent) reportingComponent!: EnrollmentPropertyReportingComponent;
  @ViewChild(EnrollmentPropertyLicensesComponent) licensesComponent!: EnrollmentPropertyLicensesComponent;
  rental!: EnrollmentRentalPropertyModel;
  taxRepresentative!: EnrollmentTaxRepresentativeModel;
  license!: RentalPropertyLicenseModel;
  owners!: PropertyOwnerModel[];
  companies!: PropertyCompanyModel[];

  isFormValid(): boolean {
    return this.ownerComponent.isFormValid()
      && this.rentalComponent.isFormValid()
      && this.reportingComponent.isFormValid()
      && this.licensesComponent.isFormValid();

  }

  getUpdatedEnrollment(): EnrollmentModel {
    const owner = this.ownerComponent.getUpdatedEnrollment();
    const rental  = this.rentalComponent.getUpdatedEnrollment();
    const reporting = this.reportingComponent.getUpdatedEnrollment();
    const license = this.licensesComponent.getUpdatedEnrollment();

    // Several steps return an enrollmentRentalProperty block (Rental Property carries the
    // appraiser office / jurisdiction the approver picked; Reporting carries the flags, built
    // from the ORIGINAL enrollment). A plain spread let the later step wipe the earlier one,
    // which is how the appraiser office was lost on approval. Merge the blocks instead.
    return {
      ...this.enrollment,
      ...owner,
      ...rental,
      ...reporting,
      ...license,
      enrollmentRentalProperty: {
        ...this.enrollment?.enrollmentRentalProperty,
        ...rental.enrollmentRentalProperty,
        ...reporting.enrollmentRentalProperty,
        ...rental.enrollmentRentalProperty, // approver's edits win over the stale copy
      },
    };
  }

  raiseFormValidations(): void {
    this.ownerComponent.raiseFormValidations();
    this.rentalComponent.raiseFormValidations();
    this.reportingComponent.raiseFormValidations();
    this.licensesComponent.raiseFormValidations();
  }

  ngOnInit(): void {
    this.rental = this.enrollment.enrollmentRentalProperty?? {};
    this.taxRepresentative = this.enrollment.taxRepresentative?? {};
    this.license = this.enrollment.enrollmentRentalPropertyLicense?? {};
    this.companies = this.enrollment.companies?? [];
    this.owners = this.enrollment.owners?? [];
  }
}
